<template lang="pug">
  .content.content-waterproofing
    template(v-if="!containerType.improved")
      .included-in-price
        .included-in-price-info
          .included-in-price-info-text
            span {{$t('PVC_FILM_40')}}
            tooltip-icon(:hint="{section: 'waterproofing', key: 'pvc-film-40'}")
          .included-in-price-info-cost {{$t('PART_OF_PRICE')}}
        .included-in-price-checkbox

      .small-switcher
        .small-switcher-info
          .text
            span {{$t('GYDRO_EXT_A')}}
            tooltip-icon(:hint="{section: 'waterproofing', key: 'hydroprof-external-A'}")
          .cost(v-if="waterproofingData.external") {{waterProofCost.external| currency }}
        .small-switcher-switcher
          kraus-switcher-small(v-model="waterproofingData.external")

      .small-switcher
        .small-switcher-info
          .text
            span {{$t('GYDRO_INSIDE_B')}}
            tooltip-icon(:hint="{section: 'waterproofing', key: 'hydroprof-internal-B'}")
          .cost(v-if="waterproofingData.internal") {{waterProofCost.internal| currency }}
        .small-switcher-switcher
          kraus-switcher-small(v-model="waterproofingData.internal")

    template(v-else)
      .included-in-price
        .included-in-price-info
          .included-in-price-info-text
            span {{$t('GYDRO_INSIDE_B')}}
            tooltip-icon(:hint="{section: 'waterproofing', key: 'hydroprof-internal-B'}")
          .included-in-price-info-cost {{$t('PART_OF_PRICE')}}
        .included-in-price-checkbox

      .small-switcher
        .small-switcher-info
          .text
            span {{$t('GYDRO_EXT_A')}}
            tooltip-icon(:hint="{section: 'waterproofing', key: 'hydroprof-external-A'}")
          .cost(v-if="waterproofingData.external") {{waterProofCost.external| currency }}
        .small-switcher-switcher
          kraus-switcher-small(v-model="waterproofingData.external")
</template>
<script>
import KrausSwitcherSmall from '@/components/_common/ui/KrausSwitcherSmall';
import { mapActions, mapGetters } from 'vuex';
import TooltipIcon from '../../../../_common/ui/TooltipIcon';
export default {
  name: 'Waterproofing',
  components: { TooltipIcon, KrausSwitcherSmall },
  data() {
    return {
      waterproofingData: {
        external: null,
        internal: null
      }
    }
  },

  created() {
    this.init()
  },

  watch: {
    waterproofingData(val) {
      this.setWaterproofing(val)
    }
  },

  computed: {
    ...mapGetters([
      'waterproofing',
      'waterProofCost',
      'containerType'
    ])
  },

  methods: {
    ...mapActions([
      'setWaterproofing'
    ]),

    init() {
      if (this.waterproofing === null) {
        this.setWaterproofing({
          external: false,
          internal: false
        })
      }

      this.waterproofingData = this.waterproofing
    }
  }
}
</script>
